import React from 'react';
import { useInView } from 'react-intersection-observer';
export function Community() {
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  return <section id="community" className="py-20 bg-pink-50" data-id="element-58">
      <div className="container mx-auto px-4" data-id="element-59">
        <div className="text-center mb-12" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-61">
            Join Our e-Community
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto" data-id="element-62"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-63">
            Connect with like-minded women from around the world who are on a
            journey of growth and transformation.
          </p>
        </div>

        <div ref={ref} className={`grid md:grid-cols-2 gap-12 items-center transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-64">
          <div className="space-y-6" data-id="element-65">
            <h3 className="text-2xl font-bold text-gray-800" data-id="element-66">
              Our Target Audience
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-67">
              <TargetAudienceCard title="Married Women" data-id="element-68" />
              <TargetAudienceCard title="Divorced Women" data-id="element-69" />
              <TargetAudienceCard title="Separated Women" data-id="element-70" />
              <TargetAudienceCard title="Single Women" data-id="element-71" />
              <TargetAudienceCard title="Mothers" data-id="element-72" />
              <TargetAudienceCard title="Single Mothers" data-id="element-73" />
            </div>
            <p className="text-lg text-gray-700" data-id="element-74">
              No matter your circumstance or background, She Wins International
              Ministry is a place where you can find community, healing, and
              growth.
            </p>
            <div className="pt-4" data-id="element-75">
              <a href="#" className="bg-pink-600 hover:bg-pink-700 text-white font-medium py-3 px-8 rounded-full inline-block transition-colors duration-200" data-id="element-76">
                Join Our e-Fellowship
              </a>
            </div>
          </div>

          <div data-id="element-77">
            <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-78">
              <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-79">
                Newsletter Sign Up
              </h3>
              <form className="space-y-4" data-id="element-80">
                <div data-id="element-81">
                  <label htmlFor="name" className="block text-gray-700 mb-2" data-id="element-82">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-600" placeholder="Your Name" data-id="element-83" />
                </div>
                <div data-id="element-84">
                  <label htmlFor="email" className="block text-gray-700 mb-2" data-id="element-85">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-600" placeholder="your@email.com" data-id="element-86" />
                </div>
                <div data-id="element-87">
                  <button type="submit" className="w-full bg-pink-600 hover:bg-pink-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200" data-id="element-88">
                    Subscribe to Newsletter
                  </button>
                </div>
              </form>
              <p className="mt-4 text-sm text-gray-500" data-id="element-89">
                By subscribing, you'll receive weekly devotionals, event
                updates, and exclusive content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function TargetAudienceCard({
  title
}) {
  return <div className="bg-white rounded-md shadow-sm p-4 text-center" data-id="element-90">
      <h4 className="font-medium text-gray-800" data-id="element-91">{title}</h4>
    </div>;
}